import { PlayListActionTypes } from '../constants/cp-action-types';
import {
    getSanitizedIdFromTitle,
    PLAYLIST_STAGE,
    PLAYLIST_STATUS,
    Section,
} from '../../utils/constants/content-production';

export interface playListDataReducerInterface {
    dashBoardData: [];
    surface: string;
    locale: string;
    app: string;
    status: string;
    stage: string;
    sortBy: string;
    sortOrder: string;
    aem_id: string;
    selectedPlaylists: [];
    selectedUtutsInsidePL: [];
    fullPL: {};
    PLViewUtuts: [];
    saveFlag: boolean;
    addUtutsToPLFlag: boolean;
    searchStr: string;
    searchFrom: number;
    searchSize: number;
    plDetailViewSections: Section[];
}

const intialState = {
    dashBoardData: [],
    surface: 'all',
    locale: 'en_US',
    app: 'all',
    status: 'all',
    stage: 'all',
    sortBy: '',
    sortOrder: '',
    aem_id: '',
    selectedPlaylists: [],
    selectedUtutsInsidePL: [],
    fullPL: {},
    PLViewUtuts: [],
    saveFlag: false,
    addUtutsToPLFlag: false,
    searchStr: '',
    searchFrom: 0,
    searchSize: 12,
    plDetailViewSections: [],
} as playListDataReducerInterface;

export const playListDataReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case PlayListActionTypes.UPDATE_PL_DASHBOARD_DATA:
            return { ...state, dashBoardData: [...payload] };
        case PlayListActionTypes.UPDATE_PL_SURFACE:
            return { ...state, surface: payload };
        case PlayListActionTypes.UPDATE_PL_LOCALE:
            return { ...state, locale: payload };
        case PlayListActionTypes.UPDATE_PL_APP:
            return { ...state, app: payload };
        case PlayListActionTypes.UPDATE_PL_STATUS: {
            let stage = state.stage;
            switch (payload) {
                case PLAYLIST_STATUS.LIVE:
                    stage = PLAYLIST_STAGE.NONE;
                    break;
                case PLAYLIST_STATUS.ALL:
                    stage = PLAYLIST_STAGE.ALL;
                    break;
                case PLAYLIST_STATUS.DRAFT:
                    stage = PLAYLIST_STAGE.ALL;
                    break;
                default:
                    stage;
            }
            return {
                ...state,
                status: payload,
                stage,
            };
        }
        case PlayListActionTypes.UPDATE_PL_STAGE:
            return { ...state, stage: payload };
        case PlayListActionTypes.UPDATE_PL_SORT_ORDER:
            return { ...state, sortOrder: payload };
        case PlayListActionTypes.UPDATE_PL_SORT_BY:
            return { ...state, sortBy: payload };
        case PlayListActionTypes.UPDATE_PL_AEMID:
            return { ...state, aem_id: payload };
        case PlayListActionTypes.UPDATE_PL_SELECTED_PLS:
            return { ...state, selectedPlaylists: [...payload] };
        case PlayListActionTypes.UPDATE_FULL_PL:
            return { ...state, fullPL: { ...payload } };
        case PlayListActionTypes.UPDATE_PL_VIEW_UTUTS:
            return { ...state, PLViewUtuts: [...payload] };
        case PlayListActionTypes.UPDATE_PL_SAVE_FLAG:
            return { ...state, saveFlag: payload };
        case PlayListActionTypes.UPDATE_ADD_UTUT_TO_PL_FLAG:
            return { ...state, addUtutsToPLFlag: payload };
        case PlayListActionTypes.UPDATE_PL_SEARCH_STR:
            return { ...state, searchStr: payload };
        case PlayListActionTypes.UPDATE_PL_SEARCH_FROM:
            return { ...state, searchFrom: payload };
        case PlayListActionTypes.UPDATE_PL_SEARCH_SIZE:
            return { ...state, searchSize: payload };
        case PlayListActionTypes.UPDATE_PL_SELECTED_UTUTS:
            return { ...state, SelectedUtutsInsidePL: [...payload] };
        case PlayListActionTypes.UPDATE_PL_SECTION_NAME: {
            const currentPlDetailViewSections: any = JSON.parse(JSON.stringify(state.plDetailViewSections));
            const objIndex = currentPlDetailViewSections.findIndex((obj) => obj['id'] == payload.rec['id']);
            currentPlDetailViewSections[objIndex].title = payload.newName;
            return { ...state, plDetailViewSections: [...currentPlDetailViewSections] };
        }
        case PlayListActionTypes.UPDATE_PL_NEW_SECTION: {
            let currentPlDetailViewSections: any = JSON.parse(JSON.stringify(state.plDetailViewSections));
            const rec = {};
            rec['id'] = getSanitizedIdFromTitle(payload);
            rec['title'] = payload;
            rec['items'] = [];
            currentPlDetailViewSections = [...currentPlDetailViewSections, rec];
            return { ...state, plDetailViewSections: [...currentPlDetailViewSections] };
        }
        case PlayListActionTypes.ADD_NEW_UTUT_TO_SECTIONS: {
            const newEntry = {
                id: payload.aem_id,
                type: 'tutorial',
                _metadata: payload,
            };
            const currentPLViewPlaylists: any = JSON.parse(JSON.stringify(state.plDetailViewSections));
            currentPLViewPlaylists[currentPLViewPlaylists.length - 1]['items'] = [
                ...currentPLViewPlaylists[currentPLViewPlaylists.length - 1]['items'],
                newEntry,
            ];
            return { ...state, plDetailViewSections: [...currentPLViewPlaylists] };
        }
        case PlayListActionTypes.UPDATE_PL_DETAIL_VIEW_SECTIONS:
            return { ...state, plDetailViewSections: [...payload] };
        case PlayListActionTypes.RESET_ALL_FILTERS_PL:
            return {
                ...state,
                surface: 'all',
                locale: 'en_US',
                app: 'all',
                status: 'all',
                stage: 'all',
                sortBy: '',
                sortOrder: '',
                selectedPlaylists: [],
                fullPL: {},
                PLViewUtuts: [],
                saveFlag: false,
                addUtutsToPLFlag: false,
                searchFrom: 0,
                plDetailViewSections: [],
            };
        default:
            return state;
    }
};
